exports.f = {}.propertyIsEnumerable;



//////////////////
// WEBPACK FOOTER
// ../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-pie.js
// module id = 252
// module chunks = 0